import DefaultWrapper from './Themes/DefaultWrapper';

const Wrapper = ({ children }: { children: JSX.Element }) => (
  <DefaultWrapper>{children}</DefaultWrapper>
);

export default Wrapper;
